import styled from 'styled-components';

export const LoginContent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  width: 100%;

  z-index: 1;
  > div {
    display: flex;
    flex-direction: row;

    @media (max-width: 750px) {
      flex-direction: column;
      padding: 10px;
    }

    > aside {
      display: flex;
      flex-direction: column;
      width: calc(100% - 20px);
      justify-content: center;
      flex-wrap: wrap;
      max-width: 600px;
      min-width: 400px;

      @media (max-width: 750px) {
        max-width: 100%;
        min-width: 100%;
        margin-top: 20px;
      }
    }
  }
`;
